import { API_URL } from '../../../request'

export const singleProductUrl = () => {
  return API_URL + '/api/getSingleProduct'
}

export const updateProductUrl = () => {
  return API_URL + '/api/updateProduct'
}
